import * as _ from "lodash";
import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";
import { get } from "svelte/store";

interface StateParams {
  productId?: number | string;
  cid?: number;
  csid?: number;
  cgid?: number;
  ceid?: number;
  ccid?: number;
  indexPosition?: number;
}

interface PageEntityParams {
  path: string;
  url: string;
  stateParams?: StateParams;
}
export class PageEntity extends BaseEntityClass {
  path: string;
  url: string;
  stateParams?: StateParams;
  current_page_id: string;
  previous_page_id?: string;
  constructor(params: PageEntityParams) {
    super();
    this.type = "page";
    this.entity_version = 4;
    this.path = params.path;
    this.url = params.url;
    this.stateParams = params.stateParams;
    this.current_page_id = sessionStorage.getItem("current_page_id");
    this.previous_page_id = sessionStorage.getItem("previous_page_id");
  }

  static copyStateParams(params: object): object {
    function filter(item): boolean {
      const val = item[1];
      return !(
        val === undefined ||
        val === null ||
        val === "" ||
        (typeof val == "object" && _.isEmpty(val))
      );
    }

    return _.fromPairs(Object.entries(params).filter(filter));
  }

  static fromLocation(location: any, stateParams: object): PageEntity {
    const args = {
      path: location.path(),
      url: location.absUrl(),
    };
    stateParams = PageEntity.copyStateParams(stateParams);
    if (!_.isEmpty(stateParams)) {
      args["stateParams"] = stateParams;
    }
    return new PageEntity(args);
  }

  static fromWindowLocation(location: any, stateParams: object): PageEntity {
    const args = {
      path: location.pathname,
      url: location.href,
    };
    stateParams = PageEntity.copyStateParams(stateParams);
    if (!_.isEmpty(stateParams)) {
      args["stateParams"] = stateParams;
    }
    return new PageEntity(args);
  }
}
